import { render, staticRenderFns } from "./driverSigningRules.vue?vue&type=template&id=05273a38&scoped=true&"
import script from "./driverSigningRules.vue?vue&type=script&lang=js&"
export * from "./driverSigningRules.vue?vue&type=script&lang=js&"
import style0 from "./driverSigningRules.vue?vue&type=style&index=0&id=05273a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05273a38",
  null
  
)

export default component.exports